export default function filterDate(date) {
  const seconds = date.hasOwnProperty("_seconds") ? date._seconds : date.seconds;
  return new Date(seconds * 1000).toLocaleString("es-CO", { timeZone: "America/Bogota" });
}
